// extracted by mini-css-extract-plugin
export default {"paymentType":"PaymentType_paymentType__jl+Uj","icon":"PaymentType_icon__spSfa","label":"PaymentType_label__moqk0","radioContainer":"PaymentType_radioContainer__ifrBv"};